import Box from '@mui/material/Box';
import { ImageProps } from '../../icons/types';

export const MikeDroppedImage = ({ sx }: Readonly<ImageProps>) => {
  return (
    <Box sx={sx}>
      <svg viewBox="0 0 532 382" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M162.211 12.6027C200.013 9.0042 242.67 -13.773 271.729 12.4574C301.301 39.152 291.96 88.6436 292.423 130.143C292.894 172.446 298.841 217.529 274.384 250.681C247.761 286.77 204.999 309.241 162.211 306.65C121.065 304.159 90.9566 269.337 62.0054 237.821C33.328 206.603 -1.74172 173.965 0.0671987 130.143C1.84279 87.1276 37.2999 55.6911 70.5174 31.6113C97.3435 12.1646 129.977 15.6711 162.211 12.6027Z"
          fill="#E6F5FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M357.021 14.2249C394.093 10.3631 426.858 43.4091 452.545 74.3224C475.174 101.555 478.346 140.504 490.854 175.287C504.81 214.098 540.871 249.582 529.982 289.665C519.104 329.703 474.618 341.149 441.187 358.105C414.364 371.709 386.303 375.531 357.021 377.386C325.811 379.363 291.071 390.354 265.82 369.214C240.577 348.08 244.411 304.588 231.235 272.077C215.341 232.86 171.01 201.251 180.823 159.492C190.532 118.173 243.029 117.964 273.318 92.9925C303.357 68.2267 320.183 18.0623 357.021 14.2249Z"
          fill="#B4DDFE"
        />
        <path
          d="M406.654 230.733L429.451 251.57C430.948 252.938 433.278 252.805 434.608 251.274C435.933 249.75 435.751 247.435 434.204 246.137L410.77 226.479C410.046 225.872 409.112 225.468 408.205 225.731C406.497 226.225 405.782 227.586 405.699 228.821C405.648 229.569 406.101 230.227 406.654 230.733Z"
          fill="black"
          stroke="black"
        />
        <ellipse
          cx="8.11237"
          cy="8.11175"
          rx="8.11237"
          ry="8.11175"
          transform="matrix(-0.656133 0.754645 -0.754284 -0.656548 449.936 253.875)"
          fill="#616161"
        />
        <rect
          width="17.6997"
          height="2.21229"
          rx="1.10615"
          transform="matrix(-0.656133 0.754645 -0.754284 -0.656548 444.857 248.477)"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M230.241 41.9501C232.638 50.7884 235.762 70.6549 232.575 73.7712H212.407C212.405 73.7354 212.403 73.6997 212.401 73.664C204.926 72.8364 199.113 66.4953 199.113 58.7956V44.1836C199.113 35.9214 205.807 29.2236 214.064 29.2236H215.455C222.954 29.2236 229.164 34.7474 230.241 41.9501Z"
          fill="#181818"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M206.945 56.0054C203.741 52.242 201.572 47.6298 201.934 42.4617C202.978 27.571 223.695 30.8468 227.725 38.3623C231.755 45.8779 231.276 64.9417 226.068 66.2849C223.991 66.8206 219.566 65.5084 215.063 62.7925L217.889 82.801H201.199L206.945 56.0054Z"
          fill="#EDB795"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M211.457 53.4894C212.226 61.7543 211.918 71.1926 209.626 73.433H189.459C188.335 53.899 199.194 61.4634 199.194 43.0717C199.872 42.4098 200.511 41.7547 201.144 41.1897L201.122 40.6488C204.614 33.4956 209.045 29.9189 214.413 29.9189C222.466 29.9189 225.008 33.6682 227.172 36.8514C225.554 42.4075 219.274 43.2313 213.693 46.6946C213.035 46.1599 212.196 45.8394 211.283 45.8394C209.17 45.8394 207.458 47.5528 207.458 49.6663C207.458 51.7799 209.17 53.4933 211.283 53.4933C211.341 53.4933 211.399 53.492 211.457 53.4894Z"
          fill="#181818"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M174.362 208.804C191.045 213.472 205.438 215.807 217.542 215.807C229.646 215.807 240.889 212.212 251.27 205.022C234.945 200.23 221.5 197.834 210.936 197.834C200.372 197.834 188.18 201.491 174.362 208.804Z"
          fill="#005495"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M231.984 222.536C231.823 222.294 231.687 222.031 231.579 221.746C229.349 215.845 193.631 152.191 190.073 140.553H230.286C232.992 149.401 245.169 204.929 246.883 216.008C252.29 233.483 263.423 290.079 264.844 294C266.339 298.125 257.927 302.421 255.685 297.351C252.118 289.282 243.62 266.957 239.835 253.326C236.288 240.546 233.399 229.049 231.984 222.536Z"
          fill="#E7B291"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M199.084 230.308C182.754 234.437 123.023 241.903 118.924 243.074C114.707 244.278 111.01 235.582 116.222 233.699C124.515 230.701 147.366 223.776 161.221 220.95C172.365 218.676 182.534 216.821 189.361 215.735C188.783 196.547 186.139 150.498 187.872 140.553H223.453C221.792 150.09 207.744 219.679 205.133 226.644C204.304 229.131 201.832 230.23 199.084 230.308Z"
          fill="#EDB795"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M116.6 231.383C114.42 230.978 112.822 230.864 111.807 231.043C110.572 231.261 108.806 231.785 106.509 232.615C106.761 234.048 109.032 246.931 113.32 271.264C116.815 271.682 118.505 270.787 118.388 268.576C118.271 266.366 118.193 264.526 118.154 263.057L122.992 243.681C123.086 243.308 122.859 242.931 122.486 242.838C122.48 242.836 122.474 242.834 122.467 242.833L119.464 242.172C118.177 240.334 117.423 238.788 117.202 237.536C117.023 236.519 117.186 235.041 117.692 233.103L117.692 233.103C117.886 232.359 117.44 231.599 116.697 231.405C116.665 231.397 116.633 231.389 116.6 231.383Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M253.132 296.694C252.354 298.772 251.965 300.327 251.965 301.359C251.965 302.614 252.174 304.445 252.592 306.852C254.046 306.852 267.121 306.852 291.815 306.852C292.834 303.48 292.246 301.66 290.05 301.391C287.854 301.122 286.029 300.88 284.577 300.663L266.346 292.531C265.995 292.375 265.584 292.532 265.428 292.883C265.425 292.889 265.423 292.895 265.42 292.901L264.248 295.746C262.215 296.695 260.563 297.169 259.292 297.169C258.26 297.169 256.834 296.752 255.014 295.917L255.014 295.917C254.316 295.597 253.49 295.904 253.17 296.603C253.156 296.633 253.143 296.663 253.132 296.694Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M187.986 140.553C203.665 136.064 218.501 136.064 232.493 140.553C237.361 162.775 249.189 171.595 251.27 205.666C227.625 217.421 198.417 197.283 174.077 208.746C167.123 192.712 176.859 154.097 187.986 140.553Z"
          fill="#0078D6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M255.443 112.937L282.9 109.19C288.392 106.133 293.445 104.064 298.059 102.982C299.357 102.944 301.422 103.416 298.345 105.982C295.269 108.548 292.147 111.387 292.695 112.757C293.244 114.126 296.105 113.617 296.579 115.723C296.895 117.128 292.251 117.356 282.648 116.408L260.369 125.245L255.443 112.937ZM169.189 119.296L184.417 119.353C167.719 156.951 159.012 176.636 158.297 178.409C156.688 182.399 160.093 188.476 161.549 191.742C156.807 193.866 157.312 186.002 151.329 188.787C145.868 191.329 141.714 195.935 135.405 192.039C134.629 191.56 133.779 189.757 135.833 188.348C140.949 184.838 148.323 178.694 149.319 176.672C150.678 173.914 157.301 154.789 169.189 119.296Z"
          fill="#EDB795"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M210.9 70.9727L222.823 71.7674C225.76 98.3482 241.754 115.138 277.565 109.454L282.322 143.684C248.852 148.012 219.498 134.604 213.482 98.3031C211.925 88.9058 210.695 79.1261 210.9 70.9727Z"
          fill="#EEEEEE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M205.018 67.5043L223.083 71.6439C223.083 102.732 232.981 122.567 238.057 145.424H189.269C188.581 153.322 188.159 161.44 187.939 169.777H151.408C159.686 125.707 177.159 91.6127 203.825 67.4932H205.009L205.018 67.5043Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M196.966 101.073C195.708 120.446 196.448 135.229 199.184 145.425H189.268C190.63 129.779 193.032 114.995 196.966 101.073V101.073Z"
          fill="#EEEEEE"
        />
        <path
          d="M292.078 128.029C304.717 145.382 328.968 200.235 324.863 280.824C326.669 260.203 334.955 219.435 353.657 221.328C372.358 223.222 369.622 279.133 365.915 306.853C370.002 268.091 384.107 247.073 398.826 244.23"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="10 15"
        />
      </svg>
    </Box>
  );
};
